export default __webpack_public_path__ + "static/media/dizzy-spirits-sm.6f744500.png";